import React, { useState } from "react";
import { deleteBlog } from "../../../utils/apis/func";
import { useNavigate } from "react-router-dom";

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: string | undefined;
}

const UsersModal: React.FC<any> = ({
  isOpen,
  onClose,
  id,
  setFieldValue,
  customers,
  providers,
  onSelect
}) => {
  const navigate = useNavigate();

  const [isDeleting, setIsDeleting] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleDelete = async () => {
    setIsDeleting(true);
    const res = await deleteBlog(id);

    if (res.status === 201 || res.status === 200 || res.status === 204) {
      navigate("/blog");
    } else {
      alert("something went wrong");
    }
    setIsDeleting(false);
  };

  const filteredUsers = [...customers, ...providers].filter((item) =>
    (item?.businessName ? item?.businessName : `${item.firstName} ${item.lastName}`)
      .toLowerCase()
      ?.includes(searchTerm.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
      <div className="bg-white p-6 rounded-md lg:w-3/5 sm:4/5 lg:h-4/5 sm:h-[80vh]">
        <h2 className="text-lg font-medium mb-4">Users</h2>
        <p className="mb-4">Select User you want to send a notification to</p>
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full p-2 mb-4 border rounded-md"
        />
        <div className="bg-gray-300 lg:max-h-[70%] sm:max-h-[80%] overflow-y-auto">
          {filteredUsers.map((item) => (
            <div
              key={item._id || item.id}
              className="cursor-pointer px-4 py-1 hover:bg-gray-400 flex flex-row justify-between"
              onClick={() => {
                // setFieldValue(item._id ?? item.id);
                onSelect(item)
              }}
            >
              <div className="w-3/4">
                {item?.businessName ? item?.businessName : `${item.firstName} ${item.lastName}`}
              </div>
              <div>
                {item?.accountType}
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-end mt-4">
          <button
            onClick={()=>{
                onClose();
            }}
            className="mr-2 bg-[#FF0000] text-white font-bold w-1/6 text-gray-800 px-4 py-2 rounded-md "
          type="button"
          >
            Cancel
          </button>
          {/* <button
            onClick={}
            className="bg-[#88087B] text-white px-4 py-2 rounded-md hover:bg-[#88087B]/75"
            disabled={isDeleting}
            type="button"
          >
            {isDeleting ? "processing..." : "Proceed"}
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default UsersModal;
